import styled from 'styled-components';

export const StyledClipboardInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  grid-gap: 30px;
  align-items: center;
  .clipboard-input {
    label {
      font-family: 'Open Sans', sans-serif;
    }
    input {
      font-size: 14px;
    }
    & > div {
      background-color: ${({theme}) => theme.surface.subtle};
    }
  }
`;

export const StyledCopyButton = styled.button`
  width: 50px;
  height: 50px;
  color: ${({theme}) => theme.text.secondary};
  font-size: 20px;
  outline: none;
  border: 1px solid ${({theme}) => theme.surface.border};
  background-color: ${({theme}) => theme.overlay.accentMedium};
  border-radius: 50%;
  transition: all .3s ease;
  &:hover {
    color: ${({theme}) => theme.text.inverse};
    background-color: ${({theme}) => theme.overlay.accentStrong};
  }
`;